<div class="start">{{ "{" }}</div>
<ng-template
  [ngTemplateOutlet]="entryLevel"
  [ngTemplateOutletContext]="{ $implicit: htmlDatas }"
></ng-template>
<div class="end">{{ "}" }}</div>
<ng-template #entryLevel let-datas>
  <div class="entry" *ngFor="let entry of datas">
    <span class="entry-key">"{{ entry.key }}": </span>
    <span
      *ngIf="!isObject(entry.value)"
      [ngClass]="['entry-value', elemType(entry.value)]"
      >{{ isString(entry.value) ? '"' : "" }}{{ entry.value
      }}{{ isString(entry.value) ? '"' : "" }}</span
    >
    <span
      *ngIf="isObject(entry.value)"
      [ngClass]="['entry-value', elemType(entry.value)]"
    >
      <span class="start">{{ "{" }}</span>
      <ng-template
        [ngTemplateOutlet]="entryLevel"
        [ngTemplateOutletContext]="{ $implicit: entry.value }"
      ></ng-template>
      <div class="end">{{ "}" }}</div>
    </span>
  </div>
</ng-template>
